"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateItineraryHistory = void 0;
const orders_1 = require("../orders");
const updateItineraryHistory = (currentItinerary, itineraryHistory, setItineraryHistory) => {
    // Only proceed if we have a valid itinerary
    if (!currentItinerary || currentItinerary.length === 0) {
        return;
    }
    // Check if the current itinerary has valid rates
    const isValid = !currentItinerary
        .filter((item) => item !== null && item !== undefined)
        .some((golf) => {
        if (!golf)
            return true;
        return (0, orders_1.getOrderLineTotalByType)(golf.config, "GOLF") === 0;
    });
    // Only add to history if it's valid
    if (isValid) {
        // Get the last item in the history (if it exists)
        const lastItem = itineraryHistory.length > 0
            ? itineraryHistory[itineraryHistory.length - 1]
            : null;
        // Check if the current itinerary is different from the last one
        const isDifferent = !lastItem ||
            JSON.stringify(lastItem) !== JSON.stringify(currentItinerary);
        // Only update history if the itinerary has changed and is valid
        if (isDifferent) {
            setItineraryHistory([...itineraryHistory, currentItinerary]);
        }
    }
};
exports.updateItineraryHistory = updateItineraryHistory;
